<template>
  <q-input v-model="selectedDate" :label="config.label" class="month-picker-input" type="text"
    @click="popupVisible = true" bottom-slots :clearable="config.clearable" :readonly="config.readonly">
    <template v-slot:append>
      <q-icon name="event" class="cursor-pointer" color="grey-7">
        <q-popup-proxy v-if="!config.readonly" ref="qDateProxy" v-model="popupVisible" :breakpoint="9999999"
          transition-show="scale" transition-hide="scale">
          <month-picker :default-year="getYear()" lang="en" :default-month="getMonth()" clearable :range="config.range"
          :rootModel="rootModel"
            @input="populateInput" />
        </q-popup-proxy>
      </q-icon>
    </template>
  </q-input>
</template>

<script>
import MonthPicker from './MonthPicker.vue'
import monthPicker from './month-picker'
import moment from 'moment'
import { firebase } from '@firebase/app'
const { Timestamp } = firebase.firestore
export default {
  name: 'MonthPickerWithInput',
  directives: {
    clickOutside: {
      bind: function (el, binding, vnode) {
        el.event = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event)
          }
        }
        document.body.addEventListener('click', el.event)
      },
      unbind: function (el) {
        document.body.removeEventListener('click', el.event)
      }
    }
  },
  components: {
    MonthPicker
  },
  model: {
    prop: 'modelProps',
    event: 'input'
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    modelProps: {
      type: [String, Object],
      default: ''
    },
    rootModel: {
      type: [String, Object],
      default: () => {}
    },
    parent: {
      type: Object,
      default: () => {}
    },
    originModel: {
      type: String,
      default: () => {}
    }
  },
  data() {
    return {
      monthPickerVisible: false,
      selectedDate: this.initValue(),
      popupVisible: false,
      originDate: null
    }
  },
  watch: {
    selectedDate(newValue) {
      if(this.R.isNil(newValue)) {
        this.emitValue(this.originDate.from)
      }
    }
  },
  methods: {
    initValue() {
      if(!this.modelProps) return null
      if(this.config.modelTimestamp) {
        return this.convertTimestampToString(this.modelProps)
      }
      return this.config.format ? moment(this.modelProps, this.config.format).format('MM/YYYY') : this.modelProps
    },
    convertTimestampToString(value, format) {
      return moment(value instanceof Timestamp ? value.toDate() : value).format(format ? format : 'MM/YYYY')
    },
    populateInput(date) {
      this.originDate = date
      this.selectedDate = moment(date.from).format('MM/YYYY')
      this.emitValue(this.originDate.from)
      this.monthPickerVisible = false
      this.popupVisible = false
    },
    emitValue(newValue) {
      if(this.config.modelTimestamp) {
        this.$emit("input", Timestamp.fromDate(newValue))
      } else {
        this.$emit("input", this.config.format ? moment(newValue).format(this.config.format) : this.selectedDate)
      }
    },
    getMonth() {
      if(!this.selectedDate) {
        return null
      }
      return moment(this.selectedDate, 'MM/YYYY').month() + 1
    },
    getYear() {
      if(!this.selectedDate) {
        return null
      }
      return moment(this.selectedDate, 'MM/YYYY').year()
    }
  }
} 
</script>
